const sqlTimeToJS = (sqlTime) => {
  if (!sqlTime) return null;
  const [hours, minutes, seconds] = sqlTime.split(":");
  const d = new Date();
  d.setHours(parseInt(hours), parseInt(minutes), parseInt(seconds));
  return d;
};

export default sqlTimeToJS;